export default __webpack_public_path__ + "static/media/webpage-ig.07f780e2.svg";